import cx from "classnames";
import React from "react";
import { FieldErrorsImpl } from "react-hook-form";

import { InputError } from "@/components/elements/InputError";
import { InputLabel } from "@/components/elements/InputLabel";
import { Text } from "@/components/elements/Text";

import styles from "./styles.module.css";

export type TextAreaInputType = {
  name: string;
  label: string;
  placeholder?: string;
  helperText?: string;
  readOnly?: boolean;
  hidden?: boolean;
};

export type InputTextThemes = "dark" | "light";
export type InputTextVersion = "underline" | "box";

export interface TextAreaInputProps extends TextAreaInputType {
  id: string;
  hideLabel?: boolean;
  errors?: FieldErrorsImpl;
  disabled?: boolean;
  readOnly?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register?: any;
  theme?: InputTextThemes;
  version?: InputTextVersion;
  className?: string;
  inputClassName?: string | undefined;
}

export const TextAreaInput = ({
  label,
  hideLabel = false,
  errors,
  id,
  name,
  placeholder,
  helperText,
  disabled = false,
  readOnly = false,
  hidden = false,
  register,
  theme = "light",
  version = "underline",
  className,
  inputClassName,
}: TextAreaInputProps) => {
  return (
    <div
      className={cx(
        styles.container,
        styles[theme],
        styles[version],
        { [styles.hidden]: hidden },
        className
      )}
    >
      <InputLabel id={id} hidden={hideLabel}>
        {label}
      </InputLabel>
      <div className={styles.inputWrapper}>
        <textarea
          id={id}
          name={name}
          className={cx(styles.input, inputClassName)}
          placeholder={placeholder}
          disabled={disabled}
          {...register(name)}
          readOnly={readOnly}
        />
      </div>
      {helperText && (
        <Text size="xxs" className={styles.helperText}>
          {helperText}
        </Text>
      )}
      <InputError errors={errors} inputName={name} />
    </div>
  );
};
